import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './DiningSantaCatarina.css';

const DiningSantaCatarina: React.FC = () => {
  useEffect(() => {
    // Initialize horizontal scroll for the carousel
    const cleanup = initializeDragScroll('dining-carousel');
    return cleanup;
  }, []);

  const diningPanels = [
    {
      id: 'restaurant',
      image: images.santaCatarinaRestaurant || images.restaurantFeature,
      title: 'Our Restaurant',
      content: 'Our restaurant, for the exclusive use of Awasi guests, offers a daily menu using the finest local ingredients, adapted to your requirements. We are proud to deliver levels of culinary excellence that define us as members of Relais & Châteaux.'
    },
    {
      id: 'cuisine',
      image: images.santaCatarinaDining2 || images.foodImage,
      title: 'Classic Meets Contemporary: The Essence of Brazilian Gastronomy',
      content: 'Join us for a culinary journey through Brazil, where traditional flavors blend with contemporary flair. Our kitchen celebrates the coastal bounty with fresh seafood and tropical ingredients.'
    },
    {
      id: 'chef',
      image: images.chefSantaCatarina || images.teamMember2,
      title: 'Head Chef',
      content: 'Our culinary team creates exceptional dishes using the finest Brazilian ingredients and coastal specialties. Each meal reflects our commitment to showcasing the diverse flavors of Santa Catarina.'
    },
    {
      id: 'ingredients',
      image: images.santaCatarinaDining3 || images.foodImage,
      title: 'Brazilian coastal flavours',
      content: 'Our menu celebrates the bounty of Santa Catarina\'s coast with fresh seafood, tropical fruits, and local specialties. Each dish reflects the vibrant culinary traditions of southern Brazil.'
    }
  ];

  return (
    <div className="dining-page">
      <UnifiedNavigation variant="light" destination="santa-catarina" />
      
      {/* Horizontal Carousel Section */}
      <section className="dining-carousel-section" data-scroll-section="dining">
        <div 
          id="dining-carousel"
          className="dining-carousel"
        >
          {diningPanels.map((panel, index) => (
            <div key={panel.id} className="dining-panel">
              <div className="dining-panel__image">
                <img src={panel.image} alt={panel.title} />
              </div>
              <div className="dining-panel__content">
                <h2 className="dining-panel__title">{panel.title}</h2>
                <p className="dining-panel__text">{panel.content}</p>
                <button className="dining-panel__cta">CONTACT US</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <InstagramSection />
      <Footer variant="santa-catarina" />
    </div>
  );
};

export default DiningSantaCatarina;